// extracted by mini-css-extract-plugin
export var numpadContainer = "_h6-1";
export var phoneButton = "_h6-0";